import type { LeadFormState } from '@core/Atoms/Pdp/FormState.atom';
import type { SearchParamsType } from '@core/Atoms/SearchParams/SearchParams.atom';
import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';

import type { TrackingDataType } from './Entities/TrackingDataType.entity';
import { checkoutStartToEvent } from './Schemas/Checkout/CheckoutStart/CheckoutStartToEvent';
import { vehicleToListingEvent } from './Schemas/Listing/VehicleToListingEvent';
import { vehicleToListingFeatureEvent } from './Schemas/ListingFeature/VehicleToListingFeatureEvent';
import { marketingToEvent } from './Schemas/Marketing/MarketingToEvent';
import { userContextToEvent } from './Schemas/UserContext/UserContextToEvent';

interface Props {
  searchParams: SearchParamsType;
  userId: string | null | undefined;
  formState: LeadFormState;
  listingId: string | null;
  leadFormId?: string | undefined;
  source?: string;
  vehicle: Vehicle;
  ctaLocation: string;
}

export function generateCheckoutStartTrackingData({
  searchParams,
  userId,
  formState,
  listingId,
  leadFormId,
  vehicle,
  ctaLocation,
}: Props): Record<string, TrackingDataType> {
  const marketingDataObj = {
    marketingValues: {
      ...searchParams,
    },
  };

  const userData = {
    userId,
    values: { ...formState },
  };
  const leadStartObj = {
    listingId,
    leadType: leadFormId as string,
    ctaLocation,
  };

  // event actions
  const checkoutStartEvent = checkoutStartToEvent(leadStartObj);

  // event entities
  const userEvent = userContextToEvent(userData);
  const listingEvent = vehicleToListingEvent(vehicle);
  const marketingEvent = marketingToEvent(marketingDataObj);
  const listingFeatureEvent = vehicleToListingFeatureEvent(vehicle);

  const contextStart = [listingEvent, listingFeatureEvent, userEvent, marketingEvent];

  return {
    checkoutStart: { event: checkoutStartEvent, context: contextStart },
  };
}
